import { Directive } from '@angular/core';
import { NG_VALIDATORS, FormControl } from '@angular/forms';
import * as moment from 'moment';

//conv dd/mm/yyyy to timestamp

export function futureDateValidator(control: FormControl) {
    let date = control.value;
    let day, month, year;
    if (date) {
        var dateMoment = moment(date, "DD-MM-YYYY");
        var yesterdayMoment = moment().subtract(1, 'days');
        var tomorrowMoment = moment().add(1, 'days');
        var todayMoment = moment();
        

        if(dateMoment.isValid()){

            if(dateMoment.isBefore(tomorrowMoment)){

                return {
                    notFutureDate : true
                }
            }

        }
        

        if(!dateMoment.isValid()){

            return {
                invalid: true
            }

        }
    }


    return null;
}

@Directive({
    selector: '[futureDateValidator][ngModel]',
    providers: [
        {
            provide: NG_VALIDATORS,
            useValue: futureDateValidator,
            multi: true
        }
    ]
})
export class FutureDateValidator {
}